import styled from 'styled-components'
import { Body2 } from 'components/layout/text'
import { Text } from 'roadie-ui'

type NumberedListProps = {
  listItems: string[]
}

const List = styled.div`
  display: block;
  width: fit-content;
  margin: 0 auto;
`

const ListItem = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 1.2rem;
  }
`

const ListItemIndex = styled.span`
  background-color: ${(props) => props.theme.colors.primaryLighter};
  color: ${(props) => props.theme.colors.black};
  width: 1.8rem;
  height: 1.8rem;
  border-radius: 50%;
  margin-right: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NumberedList = (props: NumberedListProps) => {
  return (
    <List id="numbered-list-items">
      {props.listItems.map((text, index) => (
        <ListItem key={`step-${text}`}>
          <ListItemIndex>
            <Text.Caption $color="neutral-black" $fontWeight="500">
              {index + 1}
            </Text.Caption>
          </ListItemIndex>
          <Body2>{text}</Body2>
        </ListItem>
      ))}
    </List>
  )
}
